import { classNames, React, observer, Fragment } from '@api'
import { useCatalogItemSidebarDetailsStore } from '@design-board/stores'
import {ui} from '@stores'
import * as css from './PrimaryDetails.css'
import { FormControlLabel, Switch } from '@material-ui/core'
import {CatalogFieldRenderer} from '@lazy'

export const CatalogItemModelH1 = observer<React.HTMLProps<HTMLHeadingElement>>(({className, ...props}) => {
  const {detailDef: {modal}} = useCatalogItemSidebarDetailsStore()

  return modal?.h1 ? <div {...props}
                         data-grid-area='h1'
                         className={classNames(css.h1, className)}>
    <CatalogFieldRenderer align={'modal'} field={modal.h1}/>
  </div> : null
})

export const CatalogItemModelH2 = observer<React.HTMLProps<HTMLHeadingElement>>( ({className, ...props}) => {
  const {detailDef: {modal}} = useCatalogItemSidebarDetailsStore()

  return modal?.h2 ? <div {...props}
                         data-grid-area='h2'
                         className={classNames(css.h2, className)}>
    <CatalogFieldRenderer align={'modal'} field={modal.h2}/>
  </div> : null
})

export const CatalogItemModelLastSync = observer<React.HTMLProps<HTMLHeadingElement>>(({className, ...props}) => {
  const {detailDef: {modal}} = useCatalogItemSidebarDetailsStore()

  if (ui.settings.noPublish) return null

  return modal?.lastSync ? <div {...props}
                                 data-grid-area='lastSync'
                                 className={classNames(css.lastSync, className)}>
    <CatalogFieldRenderer align={'modal'} field={modal.lastSync}/>
  </div> : null
})

export const CatalogItemStatus = observer<React.HTMLProps<HTMLHeadingElement>>( ({ className, ...props }) => {
  const { detailDef: { modal } } = useCatalogItemSidebarDetailsStore()
  if (modal?.status) {
    return <CatalogFieldRenderer className={css.status} align={'modal'} field={modal.status} />
  }

  return null
})

export const CatalogItemModeColorType = observer<React.HTMLProps<HTMLHeadingElement>>(({ className, ...props }) => {
  const { detailDef: { modal } } = useCatalogItemSidebarDetailsStore();
  
  return modal?.customCenterHeaderSections?.length ? <Fragment>
    {modal?.customCenterHeaderSections?.map((f, i) => {
      return <div key={i} {...props} data-grid-area='customHeaderSection' className={classNames(css.customHeaderSection, className)}><CatalogFieldRenderer align={'modal'} field={f} /></div>
    })}
  </Fragment>: null
})

export const CatalogItemSwitch = observer(() => {
  const { data, showMultipleTabs } = useCatalogItemSidebarDetailsStore()
  return showMultipleTabs ? <FormControlLabel
    control={
      <Switch
        checked={data?.multiple}
        onChange={() => { data.multiple = !data.multiple }}
        name="multiple"
        color="secondary"
      />
    }
    label={data?.multiple ? "Multiple Products" : 'Single Product'}
  /> : null
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/PrimaryDetails.tsx